import { defineStore } from "pinia";
import Services from '@/services/sutting/governoratesServices'
import { mapList, mapGovernorate } from '@/helpers/mapFuncs'

export const useGovernorateStore = defineStore("governorate", {
persist: true,
state:()=>({
    governorate: {},
    governorates: [],
}),
getters : {
    getGovernorate() {
        return mapGovernorate(this.governorate)
    },
    getGovernorates() {
        return this.governorates.map(mapGovernorate)
    },
    getGovernoratesList() {
        return this.governorates.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setGovernorate(governorate) {
        this.governorate = governorate
    },
    setGovernorates(governorates) {
        this.governorates = governorates
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setGovernorate(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setGovernorates(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.governorates.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.governorates[this.governorates.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.governorates = this.governorates.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});